import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  backgroundImage: belongsTo('asset', { inverse: null }),
  backgroundVideo: belongsTo('asset', { inverse: null }),
  backgroundImageMobile: belongsTo('asset', { inverse: null }),
  backgroundVideoMobile: belongsTo('asset', { inverse: null }),
  children: hasMany('content-item', { inverse: 'parent' }),
  parent: belongsTo('content-item', { inverse: 'children' }),
  page: belongsTo('mlp-page', { inverse: 'contentItems' }),
  entity: belongsTo({
    polymorphic: true,
  }),
});
